import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@mui/material";
import { Pencil } from "lucide-react";

const applicantTagRowPropType = PropTypes.shape({
  userTag: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  tagName: PropTypes.string,
}).isRequired;

const ApplicantTagCell = ({ row, addTagLabel, canEditTags, onTagClick }) => {
  const readonlyPill = row.userTag ? (
    <span className="event-applicants__tag-pill event-applicants__tag-pill--readonly">
      {row.tagName}
    </span>
  ) : (
    <Typography variant="caption" className="event-applicants__label">
      —
    </Typography>
  );

  if (!canEditTags) return readonlyPill;

  if (!row.userTag) {
    return (
      <Button
        size="small"
        variant="outlined"
        dir="auto"
        className="event-applicants__tag-pill event-applicants__tag-pill--interactive"
        onClick={(event) => {
          event.stopPropagation();
          onTagClick(row);
        }}
      >
        {addTagLabel}
      </Button>
    );
  }

  return (
    <Button
      size="small"
      variant="outlined"
      dir="auto"
      className="event-applicants__tag-pill event-applicants__tag-pill--interactive"
      endIcon={<Pencil size={14} strokeWidth={1.5} />}
      onClick={(event) => {
        event.stopPropagation();
        onTagClick(row);
      }}
    >
      {row.tagName}
    </Button>
  );
};

ApplicantTagCell.propTypes = {
  row: applicantTagRowPropType,
  addTagLabel: PropTypes.string.isRequired,
  canEditTags: PropTypes.bool.isRequired,
  onTagClick: PropTypes.func.isRequired,
};

export default ApplicantTagCell;
